<template>
  <section>
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      style="margin: 20px auto 0px 15px"
    >
    </toolbar>
    <el-select
      v-model="status"
      @change="changeStatus"
      placeholder="请选择状态"
      id="inputselect"
      style="width: 200px; margin: 0px auto 10px 15px"
    >
      <el-option label="待审核" value="1"></el-option>
      <el-option label="审核通过" value="2"></el-option>
      <el-option label="驳回" value="3"></el-option>
    </el-select>
    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '50px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column type="index" width="80" align="center">
      </el-table-column>

      <el-table-column
        prop="CateName"
        label="分类名"
        width=""
        sortable
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="CustomerName"
        label="用户名"
        width=""
        sortable
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="QuestionType"
        label="问题类型"
        width=""
        sortable
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="Title"
        label="问题"
        width=""
        sortable
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="Status"
        label="状态"
        width=""
        sortable
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        width=""
        sortable
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" width align="center">
        <template slot-scope="scope">
          <span class="SpanList" @click="handleEdit(scope.row)">审核</span>
          <span class="SpanList" @click="handleDel(scope.row.Id)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar" v-if="this.users.length != 0">
      <!-- <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      > -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="total"
        style="text-align: center; margin-top: 100px"
        background
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="分类名称" prop="CateName">
          <el-input
            readonly
            v-model="editForm.CateName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题" prop="Title">
          <el-input
            readonly
            v-model="editForm.Title"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="驳回原因" prop="Title">
          <el-input v-model="editForm.Content" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >通过</el-button
        >
        <el-button
          type="danger"
          @click.native="editSubmitno"
          :loading="editLoading"
          >驳回</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="接口描述" prop="Name">
          <el-input v-model="addForm.CateName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="OrderSort">
          <el-input v-model="addForm.OrderSort" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  GetQuestionListByPage,
  QuestionInfoDelete,
  QuestionInfoUpdate,
  RejectQuestionStatus,
  AddRecordInfo,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      statusoption: [
        { key: 1, value: "待审核" },
        { key: 2, value: "审核通过" },
        { key: 3, value: "驳回" },
      ],
      status: null,
      statusvalue: 0,
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      users: [],
      //statusList: [{LinkUrl: '激活', value: true}, {LinkUrl: '禁用', value: false}],
      total: 0,
      page: 1,
      pagesize: 10,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        LinkUrl: [
          { required: true, message: "请输入接口地址", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        CateName: "",
        OrderSort: 0,
        Enabled: false,
        Content: "",
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        LinkUrl: [
          { required: true, message: "请输入接口地址", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        CateName: "",
        OrderSort: 0,
        Enabled: "",
      },
    };
  },
  methods: {
    async AddRecordInfo(action, description) {
      var user = JSON.parse(
        window.localStorage.user ? window.localStorage.user : null
      );
      let res = await AddRecordInfo({
        userName: user.uRealName + "-" + user.uLoginName,
        action: action,
        description: description,
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.CreateTime),
            "yyyy-MM-dd hh:MM:ss"
          );
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModules();
    },
    changeStatus(val) {
      this.statusvalue = val;
      this.getModules();
    },
    //获取用户列表
    getModules() {
      let para = {
        PageIndex: this.page,
        PageSize: this.pagesize,
        Name: this.filters.name,
        Status: this.statusvalue,
      };
      this.listLoading = true;

      //NProgress.start();
      GetQuestionListByPage(para).then((res) => {
        if (res.data.success) {
          this.AddRecordInfo("查询", "交流互动-咨询问答管理-查看咨询问答列表");

          this.total = res.data.response.dataCount;
          this.users = res.data.response.data;
          this.listLoading = false;
        } else {
          this.total = 0;
          this.users = [];
          this.listLoading = false;
        }
        console.log(this.users);
        //NProgress.done();
      });
    },
    //删除
    handleDel(index) {
      // let row = this.currentRow;
      // if (!row) {
      //   this.$message({
      //     message: "请选择要删除的一行数据！",
      //     type: "error",
      //   });

      //   return;
      // }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { Id: index };
          QuestionInfoDelete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.AddRecordInfo(
                "删除",
                "交流互动-咨询问答管理-删除咨询问答列表"
              );

              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit(row) {
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        LinkUrl: "",
        Name: "",
        Enabled: "true",
      };
    },
    //编辑
    editSubmit: function () {
      this.$confirm("确认该问题通过吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let paras = Object.assign({}, this.editForm);
          console.log(paras);
          let para = { Id: paras.Id };
          QuestionInfoUpdate(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.AddRecordInfo(
                "修改",
                "交流互动-咨询问答管理-审核咨询问答列表"
              );

              this.$message({
                message: "成功",
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.getModules();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    //驳回
    editSubmitno: function () {
      //RejectQuestionStatus
      this.$confirm("确认驳回该问题吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let paras = Object.assign({}, this.editForm);
          let para = { Id: paras.Id, Content: paras.Content };
          RejectQuestionStatus(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "成功",
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.getModules();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
  },
  mounted() {
    this.getModules();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    console.log(this.buttonList);
  },
};
</script>

<style scoped>
</style>
